import { useEffect } from 'react';
import './App.css';
import Settings from './pages/Settings';
import History from './pages/History';
import RewardCenter from './pages/RewardCenter';
import Health from './pages/Health';
import Specialist from './pages/Specialist';
import LabResult from './pages/LabResult';
import Wallet from './pages/Wallet';
import Withdraw from './pages/Withdraw';
import LandingPage from './pages/LandingPage';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import ChatAI from './pages/ChatAI';
import UserProfile from './component/UserProfile';
import Trivia from './pages/Trivia';
import OTP from './pages/OTP';
import LoginOTP from './pages/LoginOTP';
import VerifyChannel from './pages/VerifyChannel';
import VerifySignupChannel from './pages/VerifySignupChannel';
import Login from './pages/Login';
import Signup from './pages/Signup';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivateRoute from './component/PrivateRoute';
import TriviaGames from './pages/TriviaGames';
import SymptomSprint from './pages/SymptomSprint';
import MythOrFact from './pages/MythOrFact';
import BodyPartShuffle from './pages/BodyPartShuffle';
import HealthChainReaction from './pages/HealthChainReaction';
import FirstAidFastlane from './pages/FirstAidFastlane';
import QuickcareTrivia from './pages/QuickcareTrivia';
import HealthComboMatch from './pages/HealthComboMatch';
import WordSearch from './pages/WordSearch';

function App() {
  useEffect(() => {
    let inactivityTimer;
    const INACTIVITY_TIMEOUT = 20 * 60 * 1000; // 20 minutes in milliseconds

    const resetTimer = () => {
      // Clear existing timer
      clearTimeout(inactivityTimer);
      
      // Set new timer
      inactivityTimer = setTimeout(() => {
        // Remove token and redirect to login when inactive
        localStorage.removeItem('token');
        window.location.href = '/login';
      }, INACTIVITY_TIMEOUT);
    };

    // Set up event listeners for user activity
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
    events.forEach(event => {
      window.addEventListener(event, resetTimer);
    });

    // Initialize the timer
    resetTimer();

    // Clean up on unmount
    return () => {
      clearTimeout(inactivityTimer);
      events.forEach(event => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/terms&conditions" element={<Terms />} />
        <Route path="/privacy&policies" element={<Privacy />} />

        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/signup/otp" element={<OTP />} />
        <Route path="/login/otp" element={<LoginOTP />} />
        <Route path="/verify-channel" element={<VerifyChannel />} />
        <Route path="/verify-signup-channel" element={<VerifySignupChannel />} />
        <Route path="/name" element={<UserProfile />} />

        {/* Protected Routes */}
        <Route path="/settings" element={<PrivateRoute element={Settings} />} />
        <Route path="/withdraw" element={<PrivateRoute element={Withdraw} />} />
        <Route path="/health" element={<PrivateRoute element={Health} />} /> 
        <Route path="/history" element={<PrivateRoute element={History} />} />
        <Route path="/reward-center" element={<PrivateRoute element={RewardCenter} />} />
        <Route path="/specialist" element={<PrivateRoute element={Specialist} />} />
        <Route path="/lab-result" element={<PrivateRoute element={LabResult} />} />
        <Route path="/wallet" element={<PrivateRoute element={Wallet} />} />
        <Route path="/consultation" element={<PrivateRoute element={ChatAI} />} />
        {/* <Route path="/trivia-games" element={<PrivateRoute element={Trivia} />} /> */}
        <Route path="/trivia-games" element={<PrivateRoute element={TriviaGames} />} />
        <Route path="/symptom-sprint" element={<PrivateRoute element={SymptomSprint} />} />
        <Route path="/myth-or-fact" element={<PrivateRoute element={MythOrFact} />} />
        <Route path="/body-part-shuffle" element={<PrivateRoute element={BodyPartShuffle} />} />
        <Route path="/health-chain-reaction" element={<PrivateRoute element={HealthChainReaction} />} />
        <Route path="/first-aid-fastlane" element={<PrivateRoute element={FirstAidFastlane} />} />
        <Route path="/quickcare-trivia" element={<PrivateRoute element={QuickcareTrivia} />} />
        <Route path="/health-combo-match" element={<PrivateRoute element={HealthComboMatch} />} />
        <Route path="/word-search" element={<PrivateRoute element={WordSearch} />} />
      </Routes>
    </Router>
  );
}

export default App;